import { AsyncEngine, ownTaskFilter, subscriptionTaskFilter, unknownTaskFilter } from "@chorda/core";
import * as React from "react";
import * as ReactDOM from "react-dom";
export const EVENT_MAP = {
    click: 'onClick',
    doubleClick: 'onDoubleClick',
    change: 'onChange',
    input: 'onInput',
    focus: 'onFocus',
    blur: 'onBlur',
    keyUp: 'onKeyUp',
    keyDown: 'onKeyDown',
    submit: 'onSubmit',
};
export class ReactRenderer extends AsyncEngine {
    constructor() {
        super();
        this.roots = [];
    }
    attach(el, node) {
        this.roots.push({ el, node });
    }
    detach(node) {
        this.roots = this.roots.filter(root => root.node != node);
    }
    schedule() {
        this.scheduled = true;
        queueMicrotask(() => {
            //        requestAnimationFrame(() => {
            //            console.log('[react] render start')
            this.scheduled = false;
            this.processing = true;
            let tasks = this.tasks;
            this.tasks = [];
            const rendered = this.roots.map(root => root.node.render(true));
            this.roots.forEach((root, i) => {
                ReactDOM.render(rendered[i], root.el, () => {
                    //                    console.log('[react] dom ready')
                    tasks
                        .filter(ownTaskFilter(this))
                        .filter(subscriptionTaskFilter(this.subscriptions))
                        .filter(unknownTaskFilter(this.subscriptions));
                    console.log('[react] render end', tasks.length);
                });
            });
            this.processing = false;
        });
    }
    get events() {
        return EVENT_MAP;
    }
    isAttached(node) {
        return this.roots.find((root) => root.node == node) != null;
    }
    createVNode(key, vnodeProps, dom, children) {
        const tag = dom.tag;
        const props = Object.assign(Object.assign({}, vnodeProps), { key, className: dom.className, style: dom.styles });
        if (dom.html) {
            props.dangerouslySetInnerHTML = { __html: dom.html };
        }
        if (dom.$isSubscribed) {
            let f = domMap.get(dom);
            if (f == null) {
                f = (el) => dom.$publish(el);
                domMap.set(dom, f);
            }
            props.ref = f; //(el: HTMLElement) => dom.$publish(el)
        }
        const events = dom.$eventHandlers;
        for (let n in events) {
            if (EVENT_MAP[n]) {
                props[EVENT_MAP[n]] = events[n];
            }
        }
        return tag === false ? children : React.createElement((!tag || tag === true) ? 'div' : tag, props, children);
    }
}
const domMap = new WeakMap();
export const createReactRenderer = () => {
    return new ReactRenderer();
};
